<template>
  <div id="notifications">
    <div v-if="notifications">
      <div
        :class="{'notification-item': true, 'unread': !notification.status}"
        v-for="(notification, index) in notifications"
        :key="index"
      >
        <div class="profile-image-wrapper" v-if="notification.referenceType != 1">
          <profile-image :user="notification.user" class="profile-image" />
        </div>
        <font-awesome-icon
          v-if="notification.referenceType == 1"
          :icon="'medal'"
          size="2x"
          class="leader-medal"
        />
        <img v-if="!notification.senderUserId" src="/static/images/logo.svg" alt="" class="system-logo">
        <div class="text" v-html="notification.text"></div>
        <div class="date text-right">{{notification.date | formatDate}}</div>
      </div>
    </div>
    <loader v-else :color="'#622D90'" :size="'10px'" class="loader" />
    <div class="empty" v-if="isEmpty">{{$t('notifications.empty')}}</div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ProfileImage from '@/components/shared/users/UserImage';

export default {
  name: 'Notifications',
  components: {
    ProfileImage,
  },
  props: {},
  data() {
    return {
      notifications: undefined,
    };
  },
  created() {
    document.title = 'motivac.io';
    this.getNotifications().then((result) => {
      this.notifications = result;
    });
  },
  computed: {
    isEmpty() {
      return this.notifications && this.notifications.length === 0;
    },
  },
  methods: {
    ...mapActions({
      getNotifications: 'notifications/getNotifications',
    }),
  },
};
</script>

<style lang="scss" scoped>
#notifications {
  .loader {
    margin: 20px 0;
  }
  .empty {
    margin: 20px;
  }
  .notification-item {
    margin: 20px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    &.unread {
      font-weight: bold;
      opacity: 1;
    }
    opacity: 0.7;
    .profile-image {
      height: 40px !important;
      width: 40px !important;
      margin: 0 10px;
    }
    .text {
      font-size: 14px;
      text-align: left;
      & >>> b {
        color: $primary-color;
      }
    }
    .date {
      margin: 0 10px;
      font-size: 12px;
      color: #ccc;
    }
    .leader-medal, .system-logo {
      color: #f1c40f;
      margin: 0 10px;
    }
  }
}
</style>
